exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checked[data-v-25f25be1]{color:tomato}.purchase[data-v-25f25be1]{font-family:Oswald,sans-serif;font-weight:400;text-transform:uppercase;padding:.85rem .5rem;min-width:115px;z-index:2}.purchase span[data-v-25f25be1]{display:block}.component-actions[data-v-25f25be1]{margin-bottom:unset!important}.add-cart[data-v-25f25be1]:before{margin-left:.5rem;margin-top:2px}.add-cart span[data-v-25f25be1]{margin-left:-.2rem}", ""]);

// exports
